
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import ModalStylePageLayout from '@/components/organisms/layout/ModalStylePageLayout.vue'
import { LearningProgress } from '@/const/LearningProgress'
import { ReviewProblem } from '@/models/ReviewProblem'
import { CurriculumUnit } from '@/models/CurriculumUnit'
import DateUtils from '@/utils/DateUtils'

/**
 * 復習問題一覧
 */
@Component({
  components: {
    ModalStylePageLayout,
    ButtonSubmit,
  },
})
export default class ReviewProblemList extends Vue {
  /** 復習問題一覧 */
  @Prop()
  private problemList!: ReviewProblem[]

  /** 単元情報 */
  @Prop()
  private curriculumUnit!: CurriculumUnit

  /** 問題クリック時のイベント */
  @Prop()
  private eventClickProblem!: (level: number, code: string) => Promise<void>

  /** 戻るボタン押下時のイベント */
  @Prop()
  private eventClickBackButton!: () => void

  /**
   * 問題レベルを学習進捗に変換する
   *
   * @param reviewProblem 復習問題情報
   * @returns 学習進捗情報
   */
  private problemProgress(reviewProblem: ReviewProblem): LearningProgress.LearningProgressMaster {
    return LearningProgress.findByLevel(reviewProblem.level)
  }

  /**
   * 日付フォーマット
   *
   * @param date 日付
   * @returns フォーマットされた日付
   */
  private dateFormat(date: Date): string {
    return DateUtils.format(date, false)
  }
}
